export default {
    "很抱歉，您输入的网址在我们的网站上无法正常显示":"Sorry, the URL you entered can't be displayed normally on our website",
    "请确认网址是否正确":"Please confirm whether the website is correct",
    "该展会暂时还未对外开放":"The exhibition has not yet been opened to the public",
    "请转到智奥会展(深圳)-主场服务平台，手动选择展会":"Please go to GL events Live（ShenZhen）Co.,Ltd. and select exhibition manually",
}


// WEBPACK FOOTER //
// ./src/i18n/en-us/notFound.js